import { GridApi } from 'ag-grid-community'
import { useCallback } from 'react'
import { exportExcel } from '../../../containers/BulkSheet/excel'

export const useExcel = (gridApi: GridApi) => {
  const onExportExcel = useCallback(
    (colIds: string[]) => {
      if (!colIds || colIds.length === 0) return
      exportExcel({
        fileNamePrefix: 'flagxs_project_resourcePlanNew_',
        gridApi,
        exportColIds: colIds,
      })
    },
    [gridApi]
  )

  return {
    onExportExcel,
  }
}
